<script setup lang="ts">

</script>

<template>
  <p>&copy; 2025 Jordy Devrix. All rights reserved.</p>
</template>

<style scoped>
p {
  text-align: center;
  margin: 0;
  padding: 5px 0;
  background-color: transparent;
  backdrop-filter: blur(2px);
  color: var(--color-text-white);
}
</style>